export default {
  dashboard: "Dashboard",
  orders: "Orders",
  modified_orders: "Modified Orders",
  order_issues: "Order Issues",
  grn: "GRN",
  invoices: "Invoices",
  reviews_ratings: "Reviews & Ratings",
  inventory: "Inventory",
  issue_to_kitchen: "Issue To Kitchen",
  credit_wallet: "Credit Wallet",
  menu_items: "Menu Items",
  recipe_master: "Recipe Master",
  support: "Support",
  resreports: "Reports",
  help: "Help",
  documentation: "Documentation",
welcome: "Welcome",
  credit: "Credit",
  search_placeholder: "Search products, orders, invoices...",
  shop_now: "Shop Now",
};